<template>

    <div class="modal fade message-box" id="conversationBoxModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:9999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p v-if="conversation !== null" class="text-lg mb-0 fw-semibold">
                            <i v-if="conversation.is_internal" class="fa fa-users text-white me-2" title="Intern gesprek"></i>
                            <span v-if="!conversation.is_internal && conversation.dossier_nr">Gesprek #{{ conversation.dossier_nr }}</span>
                            <span v-else>Gesprek:</span>
                            {{ conversation.order_name }}
                        </p>
                        <span class="ms-auto me-2 text-sm text-light conversation-participants">
                            <template v-for="(item, index) in conversation.conversation_users">
                                <span :key="index" :class="{ 'former-participant': !item.is_active }">{{ item.name }}<span v-if="!item.is_active"> (verlaten)</span></span><span :key="'sep-' + index" v-if="index < conversation.conversation_users.length - 1"> · </span>
                            </template>
                        </span>
                    </div>
                    <button @click="hideModal()" type="button" class="btn-close mb-0 me-0"></button>
                </div>

                <div class="modal-body pt-3 pb-4 px-4" v-if="conversation.user_is_allowed_to_edit">

                    <div class="actions">
                        <a v-if="!conversation.is_internal && conversation.order_url" :href="conversation.order_url" target="_blank" title="Naar opdracht">
                            <i class="fa fa-external-link"></i>
                        </a>
                        <span v-if="conversation.is_internal" v-on:click="showAddOfferToConversation(conversation)" role="button" class="position-relative" title="Opdracht koppelen">
                             <i class="fa fa-folder-open"></i>
                        </span>
                        <span v-on:click="showAddAttachmentToConversation(conversation)" role="button" class="position-relative" title="Bijlagen">
                            <i class="fa fa-file-o"></i>
                            <span v-if="conversation.attachments_count > 0" class="badge badge-primary attachment-count">{{ conversation.attachments_count }}</span>
                        </span>
                        <span v-on:click="showAddUsersToConversation(conversation)" role="button" title="Gebruikersbeheer">
                            <i class="fa fa-user"></i>
                        </span>
                        <span v-on:click="hideConversation(conversation)" role="button" title="Dit gesprek archiveren">
                            <i class="fa fa-eye-slash"></i>
                        </span>
                    </div>

                    <div class="row">
                        <div class="col-12 mt-1">
                            <textarea v-model="message" class="form-control conversation-message-input" placeholder="Nieuw bericht" rows="14"></textarea>
                        </div>
                        <div class="col-12 mt-3 text-end">
                            <button class="btn btn-success text-white ms-auto px-3 py-2 text-sm" @click="addMessage()">Verstuur bericht&nbsp;&nbsp;<i class="fa fa-send"></i></button>
                        </div>
                    </div>
                </div>

                <div class="modal-body pt-3 pb-4 px-4">
                    <div v-if="conversation !== null" class="conversation">
                        <template v-for="item in conversation.messages">
                            <div v-if="item.message_class === 'system'" :key="item.id" class="message system">
                                <div class="system-message-content">
                                    <span v-html="item.message" class="text-sm"></span>
                                    <span class="date-time-stamp ms-2 text-xxs fw-medium">
                                        {{ item.created_at }}
                                    </span>
                                </div>
                            </div>
                            <div v-else :key="item.id" class="message" :class="item.message_class">
                                <div class="profile-picture">
                                    <img :src="item.avatar">
                                </div>
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        {{ item.user }}
                                    </div>
                                    <p v-html="item.message" class="fw-medium mb-1 text-sm"></p>
                                    <span class="date-time-stamp ms-auto text-xxs fw-medium">
                                        {{ item.created_at }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'conversation-modal',
    data() {
        return {
            conversation: {
                id: '',
                order_name: '',
                dossier_nr: '',
                is_internal: false,
                messages: [{
                    key: {
                        id: '',
                        message: '',
                        created_at: '',
                        user: '',
                        avatar: '',
                        message_class: '',
                    }
                }],
                conversation_users: {},
                order_url: '',
                redirect_url: null,
                user_is_allowed_to_edit: false,
            },
            redirect_url: '',
            message: '',
            conversationModal: null,
        }
    },
    methods: {
        getMessages() {
            axios.get('api/get-conversation-messages/'+this.conversation.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.conversation = response.data;
                    this.message = '';
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        addMessage() {
            axios.post('api/add-message-to-conversation', {
                conversationId: this.conversation.id,
                message: this.message,
            })
                .then(response => {
                    if (response.data.status === 422) {
                        this.conversationModal.hide();
                        throw [true, response.data.message];
                    }

                    this.getMessages();
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                });
        },
        hideConversation(conversation) {

            let parent = this;

            this.$swal({
                title: "Gesprek archiveren. Weet je het zeker?",
                text: "Deze actie kan (momenteel) niet ongedaan gemaakt worden.",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, nu archiveren",
                cancelButtonText: "Annuleren",
            }).then(

                function (callBack) {
                    if (callBack.isConfirmed) {
                        axios.post('api/hide-conversation-user', {
                            conversationId: conversation.id,
                        })
                            .then(response => {
                                if (response.data.status === 422) {
                                    throw [true, response.data.message];
                                }

                                parent.hideModal();
                            })
                            .catch(e => {
                                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                            });
                    }
                }
            );
        },
        showAddOfferToConversation(conversation) {
            axios.get('api/add-offer-to-conversation/'+conversation.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('addOfferToConversation', response.data);

                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        showAddUsersToConversation(conversation) {
            axios.get('api/add-users-to-conversation/'+conversation.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('addUsersToConversation', response.data);

                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        showAddAttachmentToConversation(conversation) {
            axios.get('api/add-attachment-to-conversation/'+conversation.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('addAttachmentToConversation', response.data);

                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        hideModal() {
            if (this.redirect_url) {
                window.location.href = this.redirect_url;

            } else {
                EventBus.$emit('refetchConversations');
                this.conversationModal.hide();
            }
        },
    },
    mounted() {
        this.conversationModal = new bootstrap.Modal(document.getElementById('conversationBoxModal'));

        EventBus.$on('refetchConversations', () => {
            if (this.conversation.id) {
                this.getMessages();
            }
        });

        EventBus.$on('conversationSelected', (conversation) => {
            this.redirect_url = conversation.redirect_url;
            this.conversation = conversation;
            this.conversationModal.show();
        });

        EventBus.$on('conversationUpdated', (conversationId) => {
            // Only refresh if this is the conversation currently being viewed
            if (this.conversation && this.conversation.id === conversationId) {
                this.getMessages();
            }
        });

        EventBus.$on('conversationLeft', (conversationId) => {
            // The current user left this conversation: close it and refresh the list.
            if (this.conversation && this.conversation.id === conversationId) {
                EventBus.$emit('refetchConversations');
                this.conversationModal.hide();
            }
        });
    },
}
</script>

<style>

.swal2-container {
    z-index: 9999;
}

.attachment-count {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 16px;
    height: 16px;
    padding: 0px 4px;
    font-size: 9px;
    line-height: 16px;
    border-radius: 8px;
    background-color: #3EBE00;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
}

.actions span[role="button"] {
    position: relative;
    display: inline-block;
}

.conversation-participants .former-participant {
    opacity: 0.6;
    font-style: italic;
}

.conversation .message.system {
    justify-content: center;
    text-align: center;
    margin: 0.5rem 0;
}

.conversation .message.system .system-message-content {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.05);
    color: #6c757d;
    font-style: italic;
}

/* Berichtveld (nieuw bericht / eerste bericht): ruimer en door de gebruiker verticaal vergrootbaar */
.conversation-message-input {
    min-height: 180px;
    resize: vertical;
}

/* Berichtveld (nieuw bericht / eerste bericht): ruimer en door de gebruiker verticaal vergrootbaar */
.conversation-message-input {
    min-height: 180px;
    resize: vertical;
}
</style>
